/** @jsxImportSource @emotion/react */
import "twin.macro";
import { ErrorPage } from "./ErrorPage";

/** @type {import("@sentry/react/dist/errorboundary").FallbackRender} */
export const ErrorFallback = ({ error, resetError }) => {
  return <ErrorPage error={error} onReset={resetError} />;
};
